// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".checkbox{column-gap:.5rem}.checkbox label{margin:0}.checkbox label,.checkbox input{cursor:pointer}\n", ""]);
// Exports
module.exports = exports;
